import React from "react";
import "./ProfileDetailTabs.css";
import ButtonGroup from "react-bootstrap/ButtonGroup"
import BorderedButton from "components/General/Form/CustomButton/BorderedButton"
//API Doc: https://react-bootstrap.netlify.app/components/button-group/


class ProfileDetailTabs extends React.Component {
  render() {
    return (
      <div className="possible_friend_button_group">
          <ButtonGroup size = "lg" className = "tabbed_possible_friend">
              {this.props.firstButtonIsActive === "true" ? (
                  <BorderedButton
                     handleOnClick = {this.props.firstButtonClick}
                     buttonClassName = "background_dark_bright_blue"
                     borderColor = "#30afc8"
                     title = {this.props.firstButtonText}
                     textClassName = "tab_label_text text_white"
                  />
                 ):(
                  <BorderedButton
                     handleOnClick = {this.props.firstButtonClick}
                     buttonClassName = "background_white"
                     borderColor = "#30afc8"
                     title = {this.props.firstButtonText}
                     textClassName = "tab_label_text text_dark_bright_blue"
                  />
                 )
              }
              {this.props.secondButtonIsActive === "true" ? (
                  <BorderedButton
                     handleOnClick = {this.props.secondButtonClick}
                     buttonClassName = "background_dark_bright_blue"
                     borderColor = "#30afc8"
                     title = {this.props.secondButtonText}
                     textClassName = "tab_label_text text_white"
                  />
                 ):(
                  <BorderedButton
                     handleOnClick = {this.props.secondButtonClick}
                     buttonClassName = "background_white"
                     borderColor = "#30afc8"
                     title = {this.props.secondButtonText}
                     textClassName = "tab_label_text text_dark_bright_blue"
                  />
                 )
              }
              {this.props.thirdButtonIsActive === "true" ? (
                  <BorderedButton
                     handleOnClick = {this.props.thirdButtonClick}
                     buttonClassName = "background_dark_bright_blue"
                     borderColor = "#30afc8"
                     title = {this.props.thirdButtonText}
                     textClassName = "tab_label_text text_white"
                  />
                 ):(
                  <BorderedButton
                     handleOnClick = {this.props.thirdButtonClick}
                     buttonClassName = "background_white"
                     borderColor = "#30afc8"
                     title = {this.props.thirdButtonText}
                     textClassName = "tab_label_text text_dark_bright_blue"
                  />
                 )
              }
              {this.props.fourthButtonIsActive === "true" ? (
                  <BorderedButton
                     handleOnClick = {this.props.fourthButtonClick}
                     buttonClassName = "background_dark_bright_blue"
                     borderColor = "#30afc8"
                     title = {this.props.fourthButtonText}
                     textClassName = "tab_label_text text_white"
                  />
                 ):(
                  <BorderedButton
                     handleOnClick = {this.props.fourthButtonClick}
                     buttonClassName = "background_white"
                     borderColor = "#30afc8"
                     title = {this.props.fourthButtonText}
                     textClassName = "tab_label_text text_dark_bright_blue"
                  />
                 )
              }
              {this.props.fifthButtonIsActive === "true" ? (
                  <BorderedButton
                     handleOnClick = {this.props.fifthButtonClick}
                     buttonClassName = "background_dark_bright_blue"
                     borderColor = "#30afc8"
                     title = {this.props.fifthButtonText}
                     textClassName = "tab_label_text text_white"
                  />
                 ):(
                  <BorderedButton
                     handleOnClick = {this.props.fifthButtonClick}
                     buttonClassName = "background_white"
                     borderColor = "#30afc8"
                     title = {this.props.fifthButtonText}
                     textClassName = "tab_label_text text_dark_bright_blue"
                  />
                 )
              }
          </ButtonGroup>
      </div>
    )
  }
}

export default ProfileDetailTabs;
